import{v4 as r}from"uuid";const t=()=>{try{return crypto.randomUUID()}catch(t){return r()}};export{t as uuidV4};